import React from 'react';
import { Box, Select } from "@amzn/awsui-components-react";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import { CopyToClipboard } from "../common/CopyToClipboard";
import { Stage } from "../../lusca-search-api/generated-src";

interface DashboardStageSelectorProps {
  stage: Stage;
  setStage: (stage: Stage) => void;
  getShareUrl: (() => Promise<string>) | null;
}

export const DashboardStageSelector: React.FC<DashboardStageSelectorProps> = ({
  stage,
  setStage,
  getShareUrl,
}) => {
  return (
    <SpaceBetween size="xs">
      <Box>Environment</Box>
      <div style={{ display: "flex", gap: "8px", alignItems: "flex-start" }}>
        <div style={{ flex: 1 }}>
          <Select
            selectedOption={{ label: stage, value: stage }}
            onChange={({ detail }) => {
              const newStage = detail.selectedOption.value as Stage || stage;
              setStage(newStage);
            }}
            options={[
              { label: Stage.Prod, value: Stage.Prod },
              { label: Stage.Gamma, value: Stage.Gamma },
            ]}
            selectedAriaLabel="Selected"
            placeholder="Select a stage"
            ariaRequired={true}
          />
        </div>
        <CopyToClipboard getContent={getShareUrl || (async () => "")} disabled={!getShareUrl}>
          Share link with filters
        </CopyToClipboard>
      </div>
    </SpaceBetween>
  );
};
